module.exports = __webpack_public_path__ + "img/user.0482eb9f.svg";